import { ServiceClass } from "../models/serviceClass.model";

var order: number[] = [3, 2, 1, 6, 5, 4, 7];

export function changeServiceClassesOrder(serviceClasses: ServiceClass[]):ServiceClass[] {
    let tmpServiceClasses: ServiceClass[] = [];

    for (let index = 0; index < order.length; index++) {
      const element: number = order[index];
      tmpServiceClasses.push(serviceClasses.filter(f => f.id == element)[0]);
    }

    return tmpServiceClasses;
  }

  export function getServiceClassOrder():number[] {
    return order;
  }